import { render } from "./monitor.vue?vue&type=template&id=988ec748&scoped=true"
import script from "./monitor.vue?vue&type=script&lang=js"
export * from "./monitor.vue?vue&type=script&lang=js"

import "./monitor.vue?vue&type=style&index=0&id=988ec748&scoped=true&lang=scss"
import "./monitor.vue?vue&type=style&index=1&id=988ec748&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-988ec748"]])

export default __exports__